<template>
  <DashboardDataSection
    v-if="currentSection && currentSection.component"
    :isMissingFilter="false"
    :sections="currentSection.children?.map((f) => ({ ...f, type: f.name }))"
    :title="currentSection.title[locale]"
    :info="currentSection.info?.[locale]"
    v-bind="currentSection.props"
  />
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import DashboardDataSection from '../components/DashboardDataSection.vue'
import { useFeature } from '@/pinia/features'

const { locale } = useI18n()
const { feature: currentSection } = useFeature('home/analytics/portfolio/buildingscore/graphs')
</script>
